import { render, staticRenderFns } from "./ElementButtons.vue?vue&type=template&id=b8aafa24&"
import script from "./ElementButtons.vue?vue&type=script&lang=js&"
export * from "./ElementButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports